import { segmentLoaderInstance } from './segment-io-loader';
import { Injectable, NgZone } from '@angular/core';
import { Angulartics2Segment } from 'angulartics2';
import { BcConfigService } from 'common/config/provider';

@Injectable()
export class BcAnalytics {
  public config;
  private _userId: string;

  constructor(private $analytics: Angulartics2Segment, bcConfig: BcConfigService, private zone: NgZone) {
    this.config = bcConfig;
    if (this.config.current.segmentIOApiKey) {
      segmentLoaderInstance.init(this.config.current.segmentIOApiKey);
    }
    this.$analytics.startTracking();
  }

  eventTrack(name: string, params?) {
    // Added promise to prevent code failure in case of any error
    return new Promise(() => {
      return this.zone.runOutsideAngular(() => { this.$analytics.eventTrack(name, params); });
    });
  }

  setUserId(userId: string): void {
    this._userId = userId;
  }

  updateUserProperties(userProperties) {
    // Added promise to prevent code failure in case of any error
    return new Promise(() => {
      if (this.$analytics.setUserProperties) {
        this.$analytics.setUserProperties({ userId: this._userId, ...userProperties });
      }

      // Custom logic to tie user to group in Segment Lib
      if (userProperties.accountId && this.config.current.segmentIOApiKey) {
        segmentLoaderInstance.setGroup(userProperties.accountId);
      }
    });
  }
}
